import React, {useEffect, useState} from 'react'
import {NavLink} from "react-router-dom";
import {NAVIGATION_ITEM} from "../../../constants/navigationItems";
import {getFromLocalStorageWithDefault, KEY_LAST_EVENTS, saveToLocalStorage} from "../../../util/localStorageZugriff";
import StartseiteDartboard from "./StartseiteDartboard";
import StartseiteLayout, {ADMINBEREICH_BEREICH, SCORER_URL, useAdminbereichOeffnen} from "./StartseiteLayout";
import StartseiteGameScoringInvitation from "./StartseiteGameScoringInvitation";
import StartseiteVideoInvitation from "./StartseiteVideoInvitation";
import StartseiteGameWatchInvitation from "./StartseiteGameWatchInvitation";

const MODI = ["K.O.", "Doppel-K.O.", "Gruppenphase", "Schweizer System", "Liga", "Weekendleague", "Kratzer", "Ranglisten"];

const ZIELGRUPPEN = [
    {
        icon: "pi pi-sitemap",
        titel: "Veranstalter",
        untertitel: "Turniere in Kneipe, Verein oder online",
        punkte: [
            "Turnier- und Ligaverwaltung – kostenlos",
            "Kostenloser Scorer für Kneipe und Zuhause",
            "Automatische Ergebnisübernahme vom Board in den Turnierbaum",
            "Liveanzeige aller laufenden Spiele, auch für den TV",
            "Statistiken zu deinen Turnieren und Ligen",
        ],
        preis: "Kostenlos mit Ergebniseingabe von Hand. Vollautomatischer Ablauf mit dem darthelfer-scorer, transparente Kosten ohne nachträgliche Rechnungen.",
    },
    {
        icon: "pi pi-trophy",
        titel: "Ligabetreiber",
        untertitel: "Onlineligen und -turniere",
        punkte: [
            "Onlinegaming auf Laptop, PC, Handy und Tablet",
            "Webcamunterstützung für interaktive Games",
            "K.O., Doppel-K.O., Gruppenphase mit K.O. und Weekendleague",
            "Statistiken und Auswertungen über alle Games",
        ],
        preis: "Onlineliga kostenlos veranstalten – vollautomatische Ligaverwaltung, auf Wunsch mit Autodarts-Anbindung.",
    },
    {
        icon: "pi pi-user",
        titel: "Spieler",
        untertitel: "Trainieren, spielen, mitmachen",
        punkte: [
            "Kostenlos online spielen und trainieren",
            "Spielen mit einem Gast – ohne Anmeldung",
            "Mit einem Klick bei Veranstalterevents anmelden",
            "Average, Spiele und Statistiken immer im Blick",
        ],
        preis: "Registrierung und Gaming sind grundsätzlich kostenlos.",
    },
];

const KEY_ARTEN = [
    {id: "game", label: "Einladung zu einem Game", komponente: <StartseiteGameScoringInvitation/>},
    {id: "video", label: "Zuschauen (Video)", komponente: <StartseiteVideoInvitation/>},
    {id: "scoring", label: "Zuschauen (Scoring)", komponente: <StartseiteGameWatchInvitation/>},
];

const ZERTIFIKATE = [
    {bild: "bdv_tournament_software.png", alt: "Zertifizierte Turniersoftware des BDV"},
    {bild: "bdv_league_software.png", alt: "Zertifizierte Ligasoftware des BDV"},
    {bild: "tdv_tournament_software.png", alt: "Zertifizierte Turniersoftware des TDV"},
];

function ZuletztBesucht() {
    const [events, setEvents] = useState([]);

    useEffect(() => {
        setEvents(getFromLocalStorageWithDefault(KEY_LAST_EVENTS, []));
    }, []);

    if (events.length === 0) {
        return null;
    }

    const verlaufLoeschen = () => {
        saveToLocalStorage(KEY_LAST_EVENTS, []);
        setEvents([]);
    }

    return <div className="dhs-zuletzt">
        <span className="dhs-zuletzt-titel"><i className="pi pi-history" aria-hidden="true"/>Zuletzt besucht</span>
        <div className="dhs-zuletzt-liste">
            {events.slice(0, 5).map(event =>
                <NavLink key={"last_event_" + event.id + "_" + event.type} className="dhs-chip"
                         to={NAVIGATION_ITEM.PUBLIC_TOURNAMENT.route + "/" + event.id}>{event.name}</NavLink>
            )}
            <button type="button" className="dhs-chip dhs-chip-leise" onClick={verlaufLoeschen}>
                <i className="pi pi-trash" aria-hidden="true"/>Verlauf löschen
            </button>
        </div>
    </div>
}

function KeyBereich() {
    const [aktiv, setAktiv] = useState(KEY_ARTEN[0].id);
    const art = KEY_ARTEN.find(tmp => tmp.id === aktiv);

    return <div className="dhs-key">
        <div className="dhs-key-tabs" role="tablist">
            {KEY_ARTEN.map(tmp =>
                <button key={tmp.id} type="button" role="tab" aria-selected={tmp.id === aktiv}
                        className={"dhs-key-tab" + (tmp.id === aktiv ? " dhs-key-tab-aktiv" : "")}
                        onClick={() => setAktiv(tmp.id)}>{tmp.label}</button>
            )}
        </div>
        <div className="dhs-key-inhalt" role="tabpanel">{art.komponente}</div>
    </div>
}

/**
 * Knopf im Hero, der in den Adminbereich wechselt (z.B. "Onlinebereich", "Veranstalterbereich").
 * Er steht innerhalb von StartseiteLayout, damit er dessen LoginDialog nutzen kann.
 */
function AdminbereichKnopf({icon, label, bereich}) {
    const adminbereichOeffnen = useAdminbereichOeffnen();
    return <button type="button" className="dhs-knopf dhs-knopf-sekundaer" onClick={() => adminbereichOeffnen(bereich)}>
        <i className={icon} aria-hidden="true"/>{label}
    </button>
}

export default function Start() {

    return <StartseiteLayout startseite={true}>
        <section className="dhs-hero">
            <StartseiteDartboard className="dhs-hero-board"/>
            <div className="dhs-container dhs-hero-inhalt">
                <div className="dhs-hero-text">
                    <span className="dhs-kicker"><span className="dhs-kicker-punkt"/>Turnier- &amp; Ligasoftware für Darts</span>
                    <h1 className="dhs-titel">Vom Board<br/>bis zum <span className="dhs-titel-akzent">Turnierbaum.</span></h1>
                    <p className="dhs-lead">
                        darthelfer verwaltet deine Turniere und Ligen, scort jedes Spiel und zeigt alle Ergebnisse live –
                        in der Kneipe, im Verein oder online.
                    </p>
                    <div className="dhs-cta">
                        <NavLink to={NAVIGATION_ITEM.PUBLIC_TOURNAMENTS.route} className="dhs-knopf dhs-knopf-primaer">
                            <i className="pi pi-bolt" aria-hidden="true"/>Events &amp; Livescores
                        </NavLink>
                        <AdminbereichKnopf icon="pi pi-sitemap" label="Veranstalterbereich" bereich={ADMINBEREICH_BEREICH.VERANSTALTER}/>
                        <AdminbereichKnopf icon="pi pi-desktop" label="Onlinebereich" bereich={ADMINBEREICH_BEREICH.ONLINE}/>
                        <a href={SCORER_URL} target="_blank" rel="noreferrer" className="dhs-knopf dhs-knopf-sekundaer">
                            <i className="pi pi-calculator" aria-hidden="true"/>darthelfer-scorer
                        </a>
                    </div>
                    <ZuletztBesucht/>
                </div>
                <div className="dhs-hero-grafik">
                    <StartseiteDartboard className="dhs-hero-board-gross"/>
                </div>
            </div>
        </section>

        <div className="dhs-modi" aria-label="Unterstützte Spielmodi">
            <div className="dhs-modi-band">
                {[...MODI, ...MODI].map((modus, index) =>
                    <span key={"modus" + index} className="dhs-modus" aria-hidden={index >= MODI.length}>{modus}</span>
                )}
            </div>
        </div>

        <section className="dhs-abschnitt">
            <div className="dhs-container">
                <div className="dhs-abschnitt-kopf">
                    <span className="dhs-abschnitt-nummer">01</span>
                    <h2>Eine Plattform für jedes Oche</h2>
                    <p>Ob Kneipenturnier, Vereinsliga oder Onlineevent – darthelfer begleitet dich vom ersten Wurf bis zur Siegerehrung.</p>
                </div>
                <div className="dhs-karten">
                    {ZIELGRUPPEN.map(gruppe =>
                        <article key={gruppe.titel} className="dhs-karte">
                            <div className="dhs-karte-icon"><i className={gruppe.icon} aria-hidden="true"/></div>
                            <h3>{gruppe.titel}</h3>
                            <div className="dhs-karte-untertitel">{gruppe.untertitel}</div>
                            <ul>
                                {gruppe.punkte.map(text => <li key={text}>{text}</li>)}
                            </ul>
                            <div className="dhs-karte-preis"><span>Kosten</span>{gruppe.preis}</div>
                        </article>
                    )}
                </div>
            </div>
        </section>

        <section className="dhs-abschnitt dhs-abschnitt-blau">
            <div className="dhs-container dhs-zweispaltig">
                <div className="dhs-abschnitt-kopf">
                    <span className="dhs-abschnitt-nummer">02</span>
                    <h2>Du hast einen Key bekommen?</h2>
                    <p>Mit einem Key steigst du direkt in ein Game ein oder schaust bei einem laufenden Spiel zu – ganz ohne Anmeldung.</p>
                </div>
                <KeyBereich/>
            </div>
        </section>

        <section className="dhs-abschnitt">
            <div className="dhs-container">
                <div className="dhs-abschnitt-kopf">
                    <span className="dhs-abschnitt-nummer">03</span>
                    <h2>Zertifiziert von den Verbänden</h2>
                    <p>darthelfer ist zertifizierte Turnier- und Ligasoftware von BDV und TDV.</p>
                </div>
                <div className="dhs-zertifikate">
                    {ZERTIFIKATE.map(zertifikat =>
                        <div key={zertifikat.bild} className="dhs-zertifikat">
                            <img src={"/images/" + zertifikat.bild} alt={zertifikat.alt}/>
                        </div>
                    )}
                </div>
                <div className="dhs-system">
                    <img src="/images/chrome.png" alt="" aria-hidden="true"/>
                    <div>
                        <strong>Systemvoraussetzungen</strong>
                        <p>
                            Wir unterstützen alle modernen Browser, empfehlen aber sehr stark Chrome – viele Funktionen nutzen
                            Techniken, die nur Chrome vollständig unterstützt. Dein Endgerät inkl. Bildschirmauflösung muss aktuellen
                            Standards entsprechen; auf Spielkonsolen oder ähnlichen Geräten funktioniert darthelfer.de nicht.
                            Sofern du diese Voraussetzungen nicht erfüllst, bitten wir dich, darthelfer.de nicht oder ausschließlich ohne Support zu nutzen.
                        </p>
                    </div>
                </div>
            </div>
        </section>

    </StartseiteLayout>
}
